module.exports = __webpack_public_path__ + "assets/89b7ffa25b84cf5d802a6a9756e02c96.svg";